import { connect } from 'react-redux';
import {
  getDomains, addDomain,
  deleteDomain, checkDomainReachability, refreshDomain,
} from '../actions/domain';
import { DomainMap } from '../presentation/DomainMap';

const mapStateToProps = state => ({
  domain: state.domain,
});

const mapDispatchToProps = dispatch => ({
  getDomains: () => dispatch(getDomains()),
  addDomain: (domainName) => dispatch(addDomain(domainName)),
  deleteDomain: (domainUrlsafe) => dispatch(deleteDomain(domainUrlsafe)),
  checkDomainReachability: (domainUrlsafe) => dispatch(checkDomainReachability(domainUrlsafe)),
  refreshDomain: (domainUrlsafe) => dispatch(refreshDomain(domainUrlsafe)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DomainMap);



// WEBPACK FOOTER //
// ./scripts/containers/DomainContainer.jsx